"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getStyles = utilities_1.memoizeFunction(function (theme, customStyles) {
    if (!theme) {
        theme = styling_1.getTheme();
    }
    var DefaultStyles = {
        root: {
            minWidth: 300
        },
        header: {
            display: "flex"
        },
        photo: {
            width: 64,
            minWidth: 64,
            height: 64,
            minHeight: 64,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        photoIconContainer: {
            borderRadius: "100%",
            width: 48,
            height: 48,
            backgroundColor: theme.palette.themePrimary,
            color: theme.palette.white,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        details: {
            padding: 8
        },
        name: {
            fontSize: styling_1.FontSizes.icon,
            fontWeight: styling_1.FontWeights.semibold,
            lineHeight: styling_1.FontSizes.icon
        },
        email: {
            marginTop: 8,
            fontSize: styling_1.FontSizes.icon,
            fontWeight: styling_1.FontWeights.regular,
            lineHeight: styling_1.FontSizes.icon
        },
        body: {
            borderTop: "1px solid " + theme.palette.neutralLight
        },
        groups: {
            padding: 8,
            lineHeight: styling_1.FontSizes.medium
        },
        group: {
            backgroundColor: theme.palette.neutralSecondary,
            color: theme.palette.white,
            padding: 8,
            borderRadius: 4,
            margin: 4,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }
    };
    return styling_1.concatStyleSets(DefaultStyles, customStyles);
});
exports.getStyles = getStyles;
